import { ModuleSetting } from "@models";
import { useCallback } from "react";
import useFetchedData, { QueryState } from "./useFetchedData";
import useServices from "./useServices";

export default function useModuleSettings(
	userId: string
): [
	QueryState<ModuleSetting[]>,
	() => Promise<void>,
	(value: ModuleSetting[]) => void
] {
	const { productService } = useServices();
	const getModuleSettings = useCallback(
		() => productService.getModuleSettingsForUser(userId),
		[productService, userId]
	);

	return useFetchedData(getModuleSettings);
}
